export const CypherToken = 'ct';
export const CypherKey = 'ck';
